module.exports = __webpack_public_path__ + "static/img/row5.2e24acd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/mobile/row5.png
// module id = WLt+
// module chunks = 12